import React, { useState, useEffect } from 'react';
import {
  Modal, Paper, Typography, Grid, TextField, Button, TableContainer,
  Table, TableHead, TableRow, TableCell, TableBody, FormControl,
  InputLabel, Select, MenuItem, IconButton, FormControlLabel,
  Checkbox, TablePagination
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useUser } from '../contexts/UserContext';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxHeight: '90vh',
  overflowY: 'auto',
  backgroundColor: '#fff',
  padding: 20,
  boxShadow: 24,
  outline: 'none',
};

const ModalPolizas = ({
  open, onClose, clasificacionesProducto, onPolizasChange,
  initialPolizas = [], idOrigen, descripcionOrigen
}) => {
  const server = process.env.REACT_APP_API_ROUTE;
  const { user } = useUser();

  const [polizaField, setPolizaField] = useState('');
  const [polizaDescripcion, setPolizaDescripcion] = useState('');
  const [polizaEstado, setPolizaEstado] = useState('');
  const [polizaDirecta, setPolizaDirecta] = useState(false);
  const [estadosPoliza, setEstadosPoliza] = useState([]);
  const [polizasConfiguradas, setPolizasConfiguradas] = useState(initialPolizas);
  const [clasificacionValores, setClasificacionValores] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [editMode, setEditMode] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [idPolizaActual, setIdPolizaActual] = useState(null);

  useEffect(() => {
    const fetchEstados = async () => {
      try {
        const res = await fetch(`${server}/MgPolizasDeSeguroEstadoes`);
        const data = await res.json();
        setEstadosPoliza(data.$values || []);
      } catch (e) {
        console.error('Error al cargar estados:', e);
      }
    };
    fetchEstados();
  }, [server]);

  useEffect(() => {
    if (open && idOrigen) cargarPolizasDesdeAPI();
  }, [idOrigen, open]);


  useEffect(() => {
    if (open && !editMode) {
      limpiarFormulario();
    }
  }, [open, editMode]);

  const cargarPolizasDesdeAPI = async () => {
    console.log('cargarPolizasDesdeAPI', idOrigen);
    if (!idOrigen) {
      // Si no hay idOrigen, limpiamos el modal
      setPolizasConfiguradas([]);
      onPolizasChange && onPolizasChange([]);
      return;
    }

    try {
      const res = await fetch(`${server}/MgPolizasDeSeguroes/byidorigen/${idOrigen}`);
      const data = await res.json();
      setPolizasConfiguradas(data.$values || []);
      onPolizasChange && onPolizasChange(data.$values);
    } catch (e) {
      console.error('Error al cargar pólizas:', e);
    }
  };

  const cargarRangosPorPoliza = async (idPoliza) => {
    try {
      const res = await fetch(`${server}/MgPolizasDeSeguroRangos/bypoliza/${idPoliza}`);
      const data = await res.json();
      const rangos = {};
      console.log(data);
      data.$values.forEach(r => {
        rangos[r.idClasificacionProducto] = {
          id: r.id,
          porcentajeCopago: r.porcentajeCopago,
          valorMinimo: r.valorMinimo,
          valorMaximo: r.valorMaximo,
        };
      });
      setClasificacionValores(rangos);
      console.log(rangos);
    } catch (e) {
      console.error('Error al cargar rangos:', e);
    }
  };

  const updateClasificacionValor = (id, campo, valor) => {
    setClasificacionValores(prev => ({
      ...prev,
      [id]: {
        ...prev[id],
        [campo]: valor
      }
    }));
  };

  const guardarRangoClasificacion = async (idPoliza, idClasificacion, valores) => {
    const datosClasificacion = {
      idPoliza,
      idClasificacionProducto: parseInt(idClasificacion),
      porcentajeCopago: Number(valores.porcentajeCopago),
      valorMinimo: Number(valores.valorMinimo),
      valorMaximo: Number(valores.valorMaximo),
      ...(valores.id ? { modificadoPor: user?.codigoUsuario } : { ingresadoPor: user?.codigoUsuario }),
    };

    if (valores?.id) {
      // UPDATE
      await fetch(`${server}/MgPolizasDeSeguroRangos/${valores.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...datosClasificacion, id: valores.id }),
      });
    } else {
      // INSERT
      await fetch(`${server}/MgPolizasDeSeguroRangos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datosClasificacion),
      });
    }
  };


  const handleGuardar = async () => {
    const basePoliza = {
      codigo: polizaField,
      descripcion: polizaDescripcion,
      idEstado: Number(polizaEstado),
      directa: polizaDirecta,
      idOrigen: idOrigen || 0,
      ...(editMode ? { modificadoPor: user?.codigoUsuario } : { ingresadoPor: user?.codigoUsuario }),
    };

    try {
      let idPoliza = idPolizaActual;
      if (editMode) {
        await fetch(`${server}/MgPolizasDeSeguroes/${idPoliza}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...basePoliza, id: idPoliza }),
        });

      } else {
        const res = await fetch(`${server}/MgPolizasDeSeguroes`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(basePoliza),
        });
        const nueva = await res.json();
        idPoliza = nueva.id;
      }

      for (const idClasificacion in clasificacionValores) {
        const valores = clasificacionValores[idClasificacion];
        if (
          valores.porcentajeCopago === '' && valores.valorMinimo === '' && valores.valorMaximo === ''
        ) {
          continue;
        }

        await guardarRangoClasificacion(idPoliza, idClasificacion, valores);
      }

      await cargarPolizasDesdeAPI();
      limpiarFormulario();
    } catch (e) {
      console.error('Error al guardar:', e);
      alert('Error al guardar.');
    }
  };

  const limpiarFormulario = () => {
    setPolizaField('');
    setPolizaDescripcion('');
    setPolizaEstado('');
    setPolizaDirecta(false);
    setClasificacionValores({});
    setEditMode(false);
    setEditIndex(null);
    setIdPolizaActual(null);
  };

  const handleEditar = (index) => {
    const poliza = filteredPolizas[index];
    setPolizaField(poliza.codigo);
    setPolizaDescripcion(poliza.descripcion);
    setPolizaEstado(poliza.idEstado);
    setPolizaDirecta(poliza.directa);
    setEditMode(true);
    setEditIndex(index);
    setIdPolizaActual(poliza.id);
    cargarRangosPorPoliza(poliza.id);
  };

  const handleEliminar = async (index) => {
    const poliza = filteredPolizas[index];
    if (!window.confirm(`¿Eliminar póliza ${poliza.codigo}?`)) return;
    try {
      await fetch(`${server}/MgPolizasDeSeguroes/${poliza.id}`, { method: 'DELETE' });
      await cargarPolizasDesdeAPI();
    } catch (e) {
      alert('Error al eliminar.');
    }
  };

  const filteredPolizas = polizasConfiguradas.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.codigo?.toLowerCase().includes(term) ||
      item.descripcion?.toLowerCase().includes(term) ||
      item.estado?.toLowerCase().includes(term)
    );
  });

  const paginatedPolizas = filteredPolizas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Modal open={open} onClose={onClose}>
      <Paper style={modalStyle}>
        <Typography variant="h6" gutterBottom>
          Configurar Pólizas para Origen: {descripcionOrigen}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField label="Código" fullWidth value={polizaField} onChange={(e) => setPolizaField(e.target.value)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField label="Descripción" fullWidth value={polizaDescripcion} onChange={(e) => setPolizaDescripcion(e.target.value)} />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>Estado</InputLabel>
              <Select value={polizaEstado} onChange={(e) => setPolizaEstado(e.target.value)}>
                {estadosPoliza.map((estado) => (
                  <MenuItem key={estado.id} value={estado.id}>{estado.descripcion}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel control={<Checkbox checked={polizaDirecta} onChange={(e) => setPolizaDirecta(e.target.checked)} />} label="Póliza Directa" />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle1">Rangos por Clasificación</Typography>
            <TableContainer style={{ maxHeight: 250, overflowY: 'auto' }} component={Paper}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Clasificación</TableCell>
                    <TableCell>% Copago</TableCell>
                    <TableCell>Valor Mínimo</TableCell>
                    <TableCell>Valor Máximo</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {clasificacionesProducto.map((clas) => (
                    <TableRow key={clas.id}>
                      <TableCell>{clas.descripcion}</TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          size="small"
                          inputProps={{ min: 0, max: 100 }}

                          value={clasificacionValores[clas.id]?.porcentajeCopago || ''}
                          onChange={(e) => {
                            const value = e.target.value;
                            const num = Number(value);

                            // Solo actualizamos si está entre 1 y 100 o si el input está vacío (permite borrar para editar)
                            if (value === '' || (num >= 1 && num <= 100)) {
                              updateClasificacionValor(clas.id, 'porcentajeCopago', value);
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          size="small"
                          inputProps={{ min: 0 }}
                          value={clasificacionValores[clas.id]?.valorMinimo || ''}
                          onChange={(e) => updateClasificacionValor(clas.id, 'valorMinimo', e.target.value)}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          size="small"
                          inputProps={{ min: 0 }}
                          value={clasificacionValores[clas.id]?.valorMaximo || ''}
                          onChange={(e) => updateClasificacionValor(clas.id, 'valorMaximo', e.target.value)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          <Grid item xs={12} container spacing={2}>
            <Grid item>
              <Button variant="contained" color="primary" onClick={handleGuardar}>
                {editMode ? 'Actualizar' : 'Agregar'}
              </Button>
            </Grid>
            {editMode && (
              <Grid item>
                <Button variant="outlined" color="warning" onClick={limpiarFormulario}>
                  Cancelar
                </Button>
              </Grid>
            )}
          </Grid>


          <Grid item xs={12}>
            <TextField fullWidth label="Buscar" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
          </Grid>

          <Grid item xs={12}>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Acciones</TableCell>
                    <TableCell>Código</TableCell>
                    <TableCell>Descripción</TableCell>
                    <TableCell>Estado</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedPolizas.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <IconButton onClick={() => handleEditar(index)}><EditIcon /></IconButton>
                        <IconButton onClick={() => handleEliminar(index)}><DeleteIcon /></IconButton>
                      </TableCell>
                      <TableCell>{item.codigo}</TableCell>
                      <TableCell>{item.descripcion}</TableCell>
                      <TableCell>{item.estado}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10]}
              component="div"
              count={filteredPolizas.length}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value))}
            />
          </Grid>

          <Grid item xs={12}>
            <Button variant="contained" color="secondary" onClick={onClose}>
              Cerrar
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
};

export default ModalPolizas;
